<template>
  <v-app :class="languageClass">
    <core-header v-if="showHeader" />
    <Alert />
    <v-main class="wd-bg-gray30 wd-pt-0">
      <NotificationBar v-if="notifications.length > 0" key="宣傳 Bar" :notifications="notifications" />

      <v-container class="main__container wd-flex wd-gap-x-6 wd-pb-0 !xs:wd-pt-10 xs:wd-pb-10">
        <aside v-if="isSideBarShown" class="wd-w-224px wd-hidden lg:wd-w-294px sm:wd-block">
          <MemberRouteList
            class="wd-rounded wd-overflow-hidden"
            header-class="wd-p-5 wd-flex wd-flex-col wd-items-center"
            avatar-class="wd-w-30 wd-h-30"
            nickname-class="!wd-mb-0 wd-text-center wd-overflow-wrap-anywhere"
            user-info-class="wd-flex wd-flex-col wd-items-center wd-gap-6 wd-mt-3"
            :is-navbar="false"
            :is-close-btn-shown="false"
            avatar-size="120"
          />
        </aside>

        <main class="wd-min-w-0 wd-flex-1 wd-min-h-min wd-bg-white wd-rounded wd-px-5 wd-pt-2 wd-pb-6 xs:wd-py-0">
          <slot />
        </main>
      </v-container>
    </v-main>
    <core-footer v-if="showFooter" mx-auto />
    <client-only>
      <HeaderMenu v-if="showHeaderMenu" />
      <UserInfoNavigation v-if="showHeaderMenu" />
    </client-only>

    <root-message-dialog />
  </v-app>
</template>

<script lang="ts" setup>
import CoreHeader from '@/components/core/Header.vue'
import CoreFooter from '@/components/core/Footer.vue'
import Alert from '@/components/notice/alert.vue'
import HeaderMenu from '@/components/navigation/header-menu.vue'
import UserInfoNavigation from '@/components/navigation/user-info-navigation.vue'
import RootMessageDialog from '@/components/dialog/root-message-dialog.vue'

import { useBreakpoints } from '@/composition/useBreakpoints'

const NotificationBar = defineAsyncComponent(() => import('@/components/navigation/notification-bar.vue'))
const MemberRouteList = defineAsyncComponent(() => import('@/components/member/MemberRouteList.vue'))

const { $store } = useNuxtApp()

const { locale } = useI18n()
const { breakpoints } = useBreakpoints()

const foreignDomainFromMichelin = computed(() => $store.getters.foreignDomainFromMichelin)
const foreignDomainFromCathay = computed(() => $store.getters.foreignDomainFromCathay)
const notifications = computed(() => $store.getters['notification/notifications'])
const fromTngMiniProgram = computed(() => $store.getters.fromTngMiniProgram)
const hideFooter = computed(() => $store.getters.hideFooter)
const hideHeaderItems = computed(() => $store.getters.hideHeaderItems)

const showHeader = computed(() => !fromTngMiniProgram.value)
const showFooter = computed(() => !foreignDomainFromMichelin.value && !hideFooter.value && !fromTngMiniProgram.value)
const showHeaderMenu = computed(() => !(hideHeaderItems.value || foreignDomainFromMichelin.value || foreignDomainFromCathay.value))
const languageClass = computed(() => `language-${locale.value}`)
const isSideBarShown = computed(() => !breakpoints.smAndDown)
</script>

<style lang="scss" src="@/assets/sass/pages/index.scss"></style>
<style lang="scss" scoped>
:deep(.main__container) {
  @apply wd-h-auto;

  .v-list-item--active {
    @apply wd-text-orange50 !important;
  }
}
</style>
